define('shared/lib/JSON3',[],function(){
    return window.JSON;
});
